import React from 'react';
import BaseTable, { AutoResizer } from 'react-base-table';
import type { BaseTableProps } from 'react-base-table';
import 'react-base-table/styles.css';

import { ITableStyleWrapper, TableStyleWrapper } from './styled';

export interface ITableProps extends Omit<BaseTableProps, 'width' | 'height'>, ITableStyleWrapper {
  width?: number;
  height?: number;
}

const Table: React.FC<ITableProps> = (props) => {
  return (
    <TableStyleWrapper {...props}>
      <AutoResizer>
        {({ width, height }) => <BaseTable width={width} height={height} {...props} />}
      </AutoResizer>
    </TableStyleWrapper>
  );
};

export default Table;
